'use client';

import { c as _c } from "react/compiler-runtime";
import type { TOC } from '@/mdx-plugins';
import { useTranslations } from 'next-intl';
import { SegmentGroup, SegmentGroupItem } from '@/components/ui/segment-group';
import { useScrollspy } from '@/hooks/use-scrollspy';
import { useRouter } from '@/i18n/navigation';
type TableOfContentsProps = {
  toc: TOC[];
};
export function TableOfContents(props) {
  const $ = _c(18);
  const {
    toc
  } = props;
  let t0;
  if ($[0] !== toc) {
    t0 = toc.map(_temp);
    $[0] = toc;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      rootMargin: "0% 0% -80% 0%"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const activeId = useScrollspy(t0, t1);
  const t = useTranslations();
  const router = useRouter();
  let t2;
  if ($[3] !== t) {
    t2 = t("blog.on-this-page");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="mb-4">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== router) {
    t4 = details => {
      router.push(`#${details.value}`);
    };
    $[7] = router;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== toc) {
    t5 = toc.map(_temp2);
    $[9] = toc;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== activeId || $[12] !== t4 || $[13] !== t5) {
    t6 = <SegmentGroup orientation="vertical" value={activeId} onValueChange={t4} className="text-sm">{t5}</SegmentGroup>;
    $[11] = activeId;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t6) {
    t7 = <div className="hidden pl-4 lg:block">{t3}{t6}</div>;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp2(item_0) {
  return <SegmentGroupItem key={item_0.url} value={item_0.url} style={{
    paddingLeft: (item_0.depth - 1) * 12
  }}>{item_0.title}</SegmentGroupItem>;
}
function _temp(item) {
  return item.url;
}